import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CheckboxCustomEvent } from '@ionic/angular';
import { slideUpDown } from 'src/app/animations';
import { TranslationKey } from 'src/app/typings/english-translation-keys';

@Component({
  selector: 'app-exercise-field-filter',
  templateUrl: './exercise-field-filter.component.html',
  styleUrls: ['./exercise-field-filter.component.scss'],
  animations: [slideUpDown]
})
export class ExerciseFieldFilterComponent implements OnInit {

  @Input() fieldName: string;

  get castedFieldName() {
    return this.fieldName as TranslationKey;
  }

  @Input() optionsMap: {[optionName: string]: number} = {};

  @Input() filtersOpenState = true;

  @Output() filtersOpenStateChange = new EventEmitter<boolean>();

  @Output() selectedOptionsChange = new EventEmitter<Set<string>>();

  @Input() selectedOptions = new Set<string>();

  constructor() { }

  ngOnInit() {
  }

  onOptionChange(event: Event, region: string) {
    // Why? because selectedOptions can be undefined, and the parent is too lazy to fix it.
    this.selectedOptions = new Set(this.selectedOptions);

    const checked = (event as CheckboxCustomEvent).target.checked;

    if (checked) {
      this.selectedOptions.add(region);
    } else {
      this.selectedOptions.delete(region);
    }

    this.selectedOptionsChange.emit(this.selectedOptions);
  }

  toggleFiltersOpenState() {
    this.filtersOpenState = !this.filtersOpenState;
    this.filtersOpenStateChange.emit(this.filtersOpenState);
  }

}
